/**
 * @deprecated Please do not use COLORS directly, use palette instead.
 */
export const COLORS = {
  // Primary
  PURPLE_116: '#4F15D6',
  PURPLE: '#5E19FF',
  PURPLE_016: '#E5DAFF',
  PURPLE_008: '#F2EDFF',
  PURPLE_20: '#F5F2FA',
  PURPLE_DARK: '#570087',

  MIDNIGHT_BLUE_116: '#0A094C',
  MIDNIGHT_BLUE: '#0C0B5A',
  MIDNIGHT_BLUE_070: '#55548B',
  MIDNIGHT_BLUE_016: '#D8D8E5',
  MIDNIGHT_BLUE_008: '#ECEBF2',

  // Secondary
  YELLOW_116: '#CA9B1E',
  YELLOW: '#F0B824',
  YELLOW_016: '#FDF4DC',
  YELLOW_008: '#FEF9ED',
  YELLOW_002: '#FFFEFB',
  YELLOW_LIGHT: '#FFD119',

  // Tertiary
  GREEN_116: '#009B56',
  GREEN: '#00B866',
  GREEN_016: '#D6F4E7',
  GREEN_008: '#EBF9F3',
  GREEN_002: '#FAFEFC',

  RED_116: '#C72A42',
  RED: '#ED324E',
  RED_016: '#FCDEE3',
  RED_008: '#FEEFF1',
  RED_002: '#FFFBFB',

  DENIM_116: '#004E80',
  DENIM: '#005D98',
  DENIM_016: '#D6E5EF',
  DENIM_008: '#EBF2F7',
  DENIM_002: '#FAFCFD',

  // Neutral
  GRAY_002: '#FBFAFA',
  GRAY_004: '#F8F7F6',
  GRAY_006: '#F3F1F0',
  GRAY_008: '#EEECEB',
  GRAY_010: '#E9E7E6',
  GRAY_016: '#DBD9D8',
  GRAY_030: '#B6B5B4',

  // Text
  TEXT_DARK: '#27292A',
  TEXT_LIGHT: '#636669',

  BLACK: '#000000',
  WHITE: '#FFFFFF',
};

export const palette = {
  action: {
    disabled: COLORS.GRAY_030,
    inactive: COLORS.GRAY_030,
  },
  background: {
    boxLight: COLORS.GRAY_002,
    boxDark: COLORS.GRAY_004,
    boxDarker: COLORS.GRAY_008,
    boxDarkest: COLORS.GRAY_016,
    grayLight: COLORS.GRAY_010,
    antiflashWhite: COLORS.GRAY_006,
    default: COLORS.GRAY_008,
    paper: COLORS.WHITE,
    tooltip: COLORS.MIDNIGHT_BLUE_070,
    purpleLight: COLORS.PURPLE_20,
    purpleDark: COLORS.PURPLE_DARK,
    yellowLight: COLORS.YELLOW_LIGHT,
  },
  common: {
    black: COLORS.BLACK,
    white: COLORS.WHITE,
  },
  charts: {
    canary: '#FFA600',
    corn: '#FEDF71',
    creme: '#B38773',
    blue: '#368BC9',
    lightBlue: '#25BCCF',
    indigo: '#3B52D9',
    magenta: '#A83DBA',
    pink: '#EC407A',
    purple: '#7E57C2',
    peach: '#EF5350',
    orchid: '#7E57C2',
    lavender: '#F0D5FF',
    plum: '#570087',
    tomato: '#FF7043',
  } as const,
  default: {
    contrastText: COLORS.WHITE,
    dark: COLORS.TEXT_DARK,
    main: COLORS.TEXT_LIGHT,
  },
  divider: COLORS.GRAY_010,
  error: {
    contrastText: COLORS.WHITE,
    dark: COLORS.RED_116,
    highlight: COLORS.RED_016,
    light: COLORS.RED_008,
    main: COLORS.RED,
  },
  info: {
    contrastText: COLORS.WHITE,
    dark: COLORS.DENIM_116,
    highlight: COLORS.DENIM_016,
    light: COLORS.DENIM_008,
    main: COLORS.DENIM,
  },
  primary: {
    contrastText: COLORS.WHITE,
    dark: COLORS.PURPLE_116,
    highlight: COLORS.PURPLE_016,
    light: COLORS.PURPLE_008,
    main: COLORS.PURPLE,
  },
  secondary: {
    contrastText: COLORS.WHITE,
    dark: COLORS.MIDNIGHT_BLUE_116,
    highlight: COLORS.MIDNIGHT_BLUE_016,
    light: COLORS.MIDNIGHT_BLUE_008,
    main: COLORS.MIDNIGHT_BLUE,
  },
  success: {
    contrastText: COLORS.WHITE,
    dark: COLORS.GREEN_116,
    highlight: COLORS.GREEN_016,
    light: COLORS.GREEN_008,
    main: COLORS.GREEN,
  },
  text: {
    disabled: COLORS.GRAY_030,
    hint: COLORS.TEXT_LIGHT,
    primary: COLORS.TEXT_DARK,
    secondary: COLORS.TEXT_LIGHT,
  },
  warning: {
    contrastText: COLORS.WHITE,
    dark: COLORS.YELLOW_116,
    highlight: COLORS.YELLOW_016,
    light: COLORS.YELLOW_008,
    main: COLORS.YELLOW,
  },
};
